export const fontStyles = [
	{ label: 'Normal', value: 'normal' },
	{ label: 'Italic', value: 'italic' },
	{ label: 'Oblique', value: 'oblique' }
];

export const textTransforms = [
	{ label: 'None', value: 'none', icon: 'NO' },
	{ label: 'Capitalize', value: 'capitalize', icon: 'Aa' },
	{ label: 'Uppercase', value: 'uppercase', icon: 'AA' },
	{ label: 'Lowercase', value: 'lowercase', icon: 'aa' }
];

export const textDecorations = [
	{ label: 'Default', value: 'auto' },
	{ label: 'Underline', value: 'underline' },
	{ label: 'Overline', value: 'overline' },
	{ label: 'Line Through', value: 'line-through' },
	{ label: 'None', value: 'none' }
];